import { useEffect, useState } from 'react';

import CsvButtonComponent from './CsvButtonComponent';
import { Criticality, SyncStatus } from './FilterComponent';
import useFetchVehiclesStatusDataCsv, { VehicleStatusDataSectionKey } from './useFetchVehiclesStatusDataCsv';

interface CsvButtonContainerProps {
    criticalityStatus: Criticality[];
    syncStatus: SyncStatus[];
    dataTabsSettings: VehicleStatusDataSectionKey[];
}

const CsvButtonContainer = ({ criticalityStatus, syncStatus, dataTabsSettings }: CsvButtonContainerProps) => {
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const { fetchVehiclesStatusDataCsv, vehiclesStatusDataCsv, isLoading } = useFetchVehiclesStatusDataCsv({
        criticalityStatus,
        syncStatus,
        dataTabsSettings,
    });
    const handleDownloadCsv = () => {
        setIsDownloading(true);
        const file = new Blob([vehiclesStatusDataCsv!], { type: 'text/csv' });
        const fileURL = URL.createObjectURL(file);
        const tempLink = document.createElement('a');
        tempLink.href = fileURL;
        tempLink.setAttribute('download', 'Export-' + new Date().toISOString().slice(0, 10) + '.csv');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        setIsDownloading(false);
    };

    useEffect(() => {
        if (vehiclesStatusDataCsv !== undefined) {
            handleDownloadCsv();
        }
    }, [vehiclesStatusDataCsv]);
    return (
        <div className="display-flex flex-column">
            <CsvButtonComponent
                fetchVehiclesStatusDataCsv={fetchVehiclesStatusDataCsv}
                isProcessing={isDownloading || isLoading}
            />
        </div>
    );
};

export default CsvButtonContainer;
